import { InventoryTask } from 'src/app/proto/generated/inv_common_message_pb';

export class InventoryTaskModel {
  work_order_work_flow_name: string;
  work_order_name: string;
  work_order_task_name: string;
  work_order_work_flow_task_name: string;
  task_status: string;
  icon: string;
  title: string;
  reason: string;
  platform: string;
  taskCanBeRun: boolean;

  static MapperList(source: InventoryTask[]): InventoryTaskModel[] {
    const list: InventoryTaskModel[] = [];
    source?.forEach((element) => {
      list.push(InventoryTaskModel.Mapper(element));
    });
    return list;
  }

  static Mapper(source: InventoryTask): InventoryTaskModel {
    const destination: InventoryTaskModel = new InventoryTaskModel();
    destination.task_status = source.getTaskStatus();
    destination.work_order_name = source.getInventoryTaskName();
    destination.work_order_task_name = source.getInventoryTaskName();
    destination.work_order_work_flow_name = source.getInventoryWorkFlowName();
    destination.work_order_work_flow_task_name =
      source.getInventoryWorkFlowTaskName();
    destination.reason = source.getComment();
    destination.taskCanBeRun = false;

    return destination;
  }

  static MapperProto(source: InventoryTaskModel): InventoryTask {
    const destination: InventoryTask = new InventoryTask();

    destination.setTaskStatus(source.task_status);
    destination.setInventoryName(source.work_order_name);
    destination.setInventoryTaskName(source.work_order_task_name);
    destination.setInventoryWorkFlowTaskName(
      source.work_order_work_flow_task_name
    );
    destination.setInventoryWorkFlowName(source.work_order_work_flow_name);
    destination.setComment(source.reason);

    return destination;
  }

  static MapperProtoList(source: InventoryTaskModel[]): InventoryTask[] {
    const destination: InventoryTask[] = [];
    for (const version of source) {
      destination.push(InventoryTaskModel.MapperProto(version));
    }
    return destination;
  }
}
